import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = ({ hideWhatsApp = false, tagline = null }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (navbarRef.current && !navbarRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <div className="navbar-wrapper" ref={navbarRef}>

      {/* ========== MAIN NAVBAR ========== */}
      <nav className="navbar">
        {/* 1. Hamburger — far left, mobile only */}
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* 2. Logo */}
        <NavLink
          to="/"
          className="logo"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <img
            src="/assets/images/roamlogo.png"
            alt="Roam The World Logo"
            className="logo-img"
          />
        </NavLink>

        {/* 3. Desktop nav links */}
        <ul className="nav-links desktop-nav">
          <li><NavLink to="/">Home</NavLink></li>
          <li><NavLink to="/tours">Tours</NavLink></li>
          <li><NavLink to="/destinations">Destinations</NavLink></li>
          <li><NavLink to="/flights">✈️ Flights</NavLink></li>
          <li><NavLink to="/mice">MICE</NavLink></li>
          <li><NavLink to="/visa">Visa Services</NavLink></li>
          <li><NavLink to="/hotels">Hotels</NavLink></li>
          <li><NavLink to="/about">About Us</NavLink></li>
          <li><NavLink to="/contact">Contact</NavLink></li>
        </ul>

        {/* 4. Right side — Phone / WhatsApp */}
        {hideWhatsApp ? (
          <div className="navbar-tagline">
            <div className="navbar-phone-numbers">
              <a href="tel:+919096785868" className="phone-link">
                <span className="phone-emoji">📞</span>
                <span>+91 90967 85868</span>
              </a>
              <a href="tel:+919175785868" className="phone-link">
                <span className="phone-emoji">📞</span>
                <span>+91 91757 85868</span>
              </a>
            </div>
          </div>
        ) : (
          <button
            className="navbar-whatsapp-btn"
            onClick={() =>
              window.open(
                "https://wa.me/919096785868?text=Hi! I'd like to know more about your travel packages.",
                "_blank"
              )
            }
          >
            <img
              src="/assets/images/whatsapp.png"
              alt="WhatsApp"
              className="whatsapp-icon-img"
            />{" "}
            WhatsApp Us
          </button>
        )}
      </nav>

      {/* Mobile dropdown */}
      {menuOpen && (
        <ul className="mobile-nav">
          <li><NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink></li>
          <li><NavLink to="/tours" onClick={() => setMenuOpen(false)}>Tours</NavLink></li>
          <li><NavLink to="/destinations" onClick={() => setMenuOpen(false)}>Destinations</NavLink></li>
          <li><NavLink to="/flights" onClick={() => setMenuOpen(false)}>Flights</NavLink></li>
          <li><NavLink to="/mice" onClick={() => setMenuOpen(false)}>MICE</NavLink></li>
          <li><NavLink to="/visa" onClick={() => setMenuOpen(false)}>Visa Services</NavLink></li>
          <li><NavLink to="/hotels" onClick={() => setMenuOpen(false)}>Hotels</NavLink></li>
          <li><NavLink to="/about" onClick={() => setMenuOpen(false)}>About Us</NavLink></li>
          <li><NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink></li>
        </ul>
      )}
    </div>
  );
};

export default Navbar;